import { getModel } from "../../utils/models";

export const EverpassImage = () => {
    return <img width={300} className="everpass-logo" src="https://cdn.upshow.tv/ui-assets/DAZNForBusiness-Inline-White.png" alt="DAZN For Business logo" />;
};

const SalesLogos = ({coBrandedLogo}) => {
    const model = getModel();
    if (model === "xi6" || model === "xid" || model === "xg2v2" || model === "xumo") {
        return (
            <>
                <EverpassImage />
                {coBrandedLogo && <img width={300} className="everpass-logo pad80" src={coBrandedLogo} alt="Co Branded logo" />}
            </>
        );
    }
    return <EverpassImage />;
};

export default SalesLogos;
